import React, { useContext, useEffect, useMemo, useState } from "react";
import moment from "moment";
import NoImage from "assets/svgs/no_image";
import { Image, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { currentUser } from "modules/utilities/utility";
import { useScalpImage } from "./store";
import { toast } from "react-toastify";
import secureLocalStorage from "react-secure-storage";
import HairFallStage from "./HairFallStage";
import { isEmpty } from "lodash";
import { CustomerProps } from "./ShowCustomer";

const ScalpImage = () => {
  const { deleteScalpImage } = useScalpImage();
  const { customerimages } = useContext(CustomerProps);

  const deleteAccess = ["super_admin"];
  const adminLevelAcess = ["admin"];
  const levelAccess = [3];
  const userLevel = secureLocalStorage.getItem("level");
  const currentUrl = window.location.href.split("/");

  const sortedImages = useMemo(() => {
    return customerimages
      ?.sort((a, b) => {
        return moment(b?.updated_at).diff(moment(a?.updated_at));
      })
      ?.map((url) => {
        return {
          imageUrl: url.image,
          imageDate: moment(url?.updated_at).format("MMM DD YYYY"),
          id: url.id,
          ...url,
        };
      });
  }, [customerimages]);

  const handleDeleteChange = (id) => {
    deleteScalpImage(id, toast);
  };

  const stageMarkFlag = sortedImages?.find((item) => !isEmpty(item?.tagged_stage));

  return sortedImages?.length ? (
    <div>
      <div
        style={{ height: "28rem", overflowY: "scroll", overflowX: "hidden" }}
        className="d-flex gap-2 flex-wrap align-items-start justify-content-around scrollable-container p-2 "
      >
        <Image.PreviewGroup>
          {sortedImages?.map((image, index) => (
            <div className="d-flex flex-column bg-secondary shadow-lg rounded-2">
              <div className="d-flex flex-column w-100  fw-bold table-row  overflow-hidden rounded-2 p-2 align-items-center">
                <Image
                  width={112}
                  height={140}
                  className={`rounded  border ${
                    index === 0 && !image?.tagged_stage && isEmpty(stageMarkFlag)
                      ? "border-danger border-2"
                      : image?.tagged_stage
                      ? "border-success border-3"
                      : "bg-secondary"
                  }`}
                  src={image.imageUrl}
                />
                {deleteAccess.includes(currentUser) ||
                (adminLevelAcess.includes(currentUser) &&
                  levelAccess.includes(userLevel)) ? (
                  <span className="pt-2 d-flex align-items-center gap-2">
                    <span className="mt-n2 text-danger">
                      <Popconfirm
                        title="Delete the Image"
                        description="Are you sure to delete this Image?"
                        onConfirm={() => handleDeleteChange(image.id)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <DeleteOutlined />
                      </Popconfirm>
                    </span>{" "}
                    <span> {image.imageDate}</span>
                  </span>
                ) : (
                  <span className="pt-2">{image.imageDate}</span>
                )}
              </div>
            </div>
          ))}
        </Image.PreviewGroup>
      </div>
      {(currentUrl.includes("lead-details") ||
        currentUrl.includes("next-call")) && (
        <div>
          <HairFallStage imageUrls={sortedImages} />
        </div>
      )}
    </div>
  ) : (
    <div
      style={{ height: "21.9rem" }}
      className="d-flex flex-1 flex-column align-items-center py-2 m-1 justify-content-center"
    >
      <div>
        <NoImage />
      </div>
      <small>No image Available</small>
    </div>
  );
};

export default ScalpImage;
